export enum RoomSelectionViewType {
  LIST = "LIST",
  GRID = "GRID",
  GRID_MOBILE = "GRID_MOBILE",
}

export enum InventoryGroupingCriteria {
  NONE = "NONE",
  CONFIGURATION = "configuration",
  CONDITION = "condition",
  MEAL_PLAN = "mealplan",
  CONFIGURATION_AND_CONDITION = "configuration,condition",
  CONFIGURATION_AND_MEAL_PLAN = "configuration,mealplan",
  CONDITION_AND_CONFIGURATION = "condition,configuration",
  CONDITION_AND_MEAL_PLAN = "condition,mealplan",
  MEAL_PLAN_AND_CONFIGURATION = "mealplan,configuration",
  MEAL_PLAN_AND_CONDITION = "mealplan,condition",
}

export enum OccupationAlternatives {
  HIDE = "HIDE",
  COLLAPSED = "COLLAPSED",
  EXPANDED = "EXPANDED",
  NO_AVAILABILITY = "NO_AVAILABILITY",
}

export enum SplitStay {
  NONE = "NONE",
  UNAVAILABLE_ONE_CHEAPER = "UNAVAILABLE_ONE_CHEAPER",
  UNAVAILABLE_MANY_CHEAPER = "UNAVAILABLE_MANY_CHEAPER",
  AVAILABLE_ONE_CHEAPER = "AVAILABLE_ONE_CHEAPER",
  AVAILABLE_BETTER_ONE_CHEAPER = "AVAILABLE_BETTER_ONE_CHEAPER",
}

export enum AccommodationSortingCriteria {
  ASCENDING = "ASCENDING",
  NO_SORTING = "NO_SORTING",
}

export enum ShowPromoCodeCriteria {
  SHOW_COLLAPSED = "showPromoCodeCollapsed",
  SHOW_EXPANDED = "showPromoCodeExpanded",
  HIDE = "hidePromoCode",
}

export enum PriceCalendar {
  SHOW_ALL_PRICES = "SHOW_ALL_PRICES",
  SHOW_SELECTED_DATE_PRICES = "SHOW_SELECTED_DATE_PRICES",
  HIDE_ALL_PRICES = "HIDE_ALL_PRICES",
}

export enum ShowExtrasConfiguration {
  HIDE_EXTRAS_BEFORE_CHECKOUT = "HIDE_EXTRAS_BEFORE_CHECKOUT",
  SHOW_EXTRAS_BEFORE_CHECKOUT = "SHOW_EXTRAS_BEFORE_CHECKOUT",
  SHOW_EXTRAS_BEFORE_CHECKOUT_DESKTOP = "SHOW_EXTRAS_BEFORE_CHECKOUT_DESKTOP",
}

export enum PendingAmountTextConfiguration {
  PAY_AT_ESTABLISHMENT = "PAY_AT_ESTABLISHMENT",
  PAY_AT_HOTEL = "PAY_AT_HOTEL",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PAY_ACCORDING_TO_CONDITIONS = "PAY_ACCORDING_TO_CONDITIONS",
  AMOUNT_REMAINING = "AMOUNT_REMAINING",
  NO_TEXT = "NO_TEXT",
}

export enum DepositRequiredTextConfiguration {
  NO_TEXT = "NO_TEXT",
  DEPOSIT_REQUIRED = "DEPOSIT_REQUIRED",
  ADVANCE_PAYMENT = "ADVANCE_PAYMENT",
}

export enum DepositCheckoutTextConfiguration {
  DEPOSIT = "DEPOSIT",
  PAY_NOW = "PAY_NOW",
  ADVANCE_PAYMENT = "ADVANCE_PAYMENT",
  PAY_ACCORDING_TO_CONDITIONS = "PAY_ACCORDING_TO_CONDITIONS",
}

export enum DepositNotRequiredTextConfiguration {
  NO_TEXT = "NO_TEXT",
  DEPOSIT_NOT_REQUIRED = "DEPOSIT_NOT_REQUIRED",
  NO_ADVANCE_PAYMENT = "NO_ADVANCE_PAYMENT",
  PAYMENT_AT_ESTABLISHMENT = "PAYMENT_AT_ESTABLISHMENT",
}

export enum TaxesText {
  TAXES_INCLUDED = "TAXES_INCLUDED",
  TAXES_EXCLUDED = "TAXES_EXCLUDED",
  TAXES_AND_FEES_INCLUDED = "TAXES_AND_FEES_INCLUDED",
  TAXES_AND_FEES_EXCLUDED = "TAXES_AND_FEES_EXCLUDED",
  TAXES_INCLUDED_FEES_EXCLUDED = "TAXES_INCLUDED_FEES_EXCLUDED",
}

export enum ExtrasTextConfiguration {
  EXTRAS = "EXTRAS",
  EXTRA_SERVICES = "EXTRA_SERVICES",
  IMPROVE_STAY = "IMPROVE_STAY",
}

export enum BundlingConfiguration {
  HIDE = "HIDE",
  SHOW = "SHOW",
  SHOW_AVAIL = "SHOW_AVAIL",
}

export enum PromosConfig {
  SHOW_ALWAYS = "SHOW_ALWAYS",
  SHOW_WHEN_APPLICABLE = "SHOW_WHEN_APPLICABLE",
}

export enum RateType {
  INCLUDED = "INCLUDED",
  EXCLUDED = "EXCLUDED",
}

export interface BehaviourEntity {
  id: string;
  roomSelectionViewType: RoomSelectionViewType;
  inventoryGroupingCriteria: InventoryGroupingCriteria;
  showBookingForm: boolean;
  showDesktopLogo: boolean;
  showMobileLogo: boolean;
  showPromos: boolean;
  showCancelMsg: boolean;
  showLanguageSelector: boolean;
  showCurrencySelector: boolean;
  showDiscountsCalculation: boolean;
  showAllReservationsIds: boolean;
  showFullReservationIds: boolean;
  hideObligatoryExtras: boolean;
  showBestPriceGuaranteed: boolean;
  showMultipleAccommodations: boolean;
  maxAccommodationsMultiReservation: string;
  showCookiePolicy: boolean;
  showInventoryPriceDiff: boolean;
  showOccupationAlternatives: OccupationAlternatives;
  splitStayConfiguration: SplitStay;
  showInactiveDiscounts: PromosConfig;
  showRestrictedHighlightMessages: PromosConfig;
  waitingListEnabled: boolean;
  showCheckoutButtonRoomUnits: boolean;
  isLogoLinkingToPropertyUrl: boolean; //logolinkstohotel;
  maxRoomsInUnitSelector: number; // maxHabitacionesFront
  roomsLeftAvailabilityLimit: number; // maxHabitacionesParaOcultarSoloQuedan
  accommodationsOrder: AccommodationSortingCriteria;
  showPromoCodeCriteria: ShowPromoCodeCriteria; // promoCode
  priceCalendar: PriceCalendar;
  showExtrasConfiguration: ShowExtrasConfiguration; //servicesCollapsed
  pendingAmountTextConfiguration: PendingAmountTextConfiguration;
  depositRequiredTextConfiguration: DepositRequiredTextConfiguration;
  depositNotRequiredTextConfiguration: DepositNotRequiredTextConfiguration;
  taxesText: TaxesText;
  unavailableURL: string;
  enginePageTitle: string; // witbookerPageTitle
  propertyUrl: string; // urlwebhotel
  hideLocked: boolean; // ocultarBloqueadas
  hideRestricted: boolean; //ocultarRestringuidas
  showRackRate: boolean; // tachaPrecios
  hasRoomCombination: boolean;
  addObligatoryExtrasRateToRoomSelection: boolean;
  showDecimalsInExtrasPage: boolean;
  isCancellationReasonRequired: boolean;
  bundlingConfiguration: BundlingConfiguration;
  showElementsSection?: string;
  logoSection?: string;
  textsSection?: string;
  resultSection?: string;
  promosSections?: string;
  otherParamsSection?: string;
  allowMultiplyPriceByUnits: boolean;
  depositCheckoutTextConfiguration: DepositCheckoutTextConfiguration;
  extrasTextConfiguration: ExtrasTextConfiguration;
  maxAccommodationsMultiReservationSection?: {
    showMultipleAccommodations?: boolean;
    maxAccommodationsMultiReservation?: number | undefined;
  };
  taxesRateType: RateType;
  overrideCurrencyAccordingToLocation: boolean;
}

export type StringBoolean = "1" | "0";
export const StringBooleanMapping: Record<string, StringBoolean> = { true: "1", false: "0" };
export const StringBooleanReverseMapping: Record<StringBoolean, boolean> = {
  "0": false,
  "1": true,
};

type InventoryGroupingCriteriaDto =
  | ""
  | "configuration"
  | "condition"
  | "mealplan"
  | "configuration,condition"
  | "configuration,mealplan"
  | "condition,configuration"
  | "condition,mealplan"
  | "mealplan,configuration"
  | "mealplan,condition";
export const InventoryGroupingCriteriaMapping: Record<
  InventoryGroupingCriteria,
  InventoryGroupingCriteriaDto
> = {
  [InventoryGroupingCriteria.NONE]: "",
  [InventoryGroupingCriteria.CONFIGURATION]: "configuration",
  [InventoryGroupingCriteria.CONDITION]: "condition",
  [InventoryGroupingCriteria.MEAL_PLAN]: "mealplan",
  [InventoryGroupingCriteria.CONFIGURATION_AND_CONDITION]: "configuration,condition",
  [InventoryGroupingCriteria.CONFIGURATION_AND_MEAL_PLAN]: "configuration,mealplan",
  [InventoryGroupingCriteria.CONDITION_AND_CONFIGURATION]: "condition,configuration",
  [InventoryGroupingCriteria.CONDITION_AND_MEAL_PLAN]: "condition,mealplan",
  [InventoryGroupingCriteria.MEAL_PLAN_AND_CONFIGURATION]: "mealplan,configuration",
  [InventoryGroupingCriteria.MEAL_PLAN_AND_CONDITION]: "mealplan,condition",
};
export const InventoryGroupingCriteriaDtoReverseMapping: Record<
  InventoryGroupingCriteriaDto,
  InventoryGroupingCriteria
> = {
  "": InventoryGroupingCriteria.NONE,
  configuration: InventoryGroupingCriteria.CONFIGURATION,
  condition: InventoryGroupingCriteria.CONDITION,
  mealplan: InventoryGroupingCriteria.MEAL_PLAN,
  "configuration,condition": InventoryGroupingCriteria.CONFIGURATION_AND_CONDITION,
  "configuration,mealplan": InventoryGroupingCriteria.CONFIGURATION_AND_MEAL_PLAN,
  "condition,configuration": InventoryGroupingCriteria.CONDITION_AND_CONFIGURATION,
  "condition,mealplan": InventoryGroupingCriteria.CONDITION_AND_MEAL_PLAN,
  "mealplan,configuration": InventoryGroupingCriteria.MEAL_PLAN_AND_CONFIGURATION,
  "mealplan,condition": InventoryGroupingCriteria.MEAL_PLAN_AND_CONDITION,
};

type AccommodationSortingCriteriaDto = "ascendingPrice" | "listPosition";
export const AccommodationSortingCriteriaMapping: Record<
  AccommodationSortingCriteria,
  AccommodationSortingCriteriaDto
> = {
  [AccommodationSortingCriteria.ASCENDING]: "ascendingPrice",
  [AccommodationSortingCriteria.NO_SORTING]: "listPosition",
};
export const AccommodationSortingCriteriaReverseMapping: Record<
  AccommodationSortingCriteriaDto,
  AccommodationSortingCriteria
> = {
  ascendingPrice: AccommodationSortingCriteria.ASCENDING,
  listPosition: AccommodationSortingCriteria.NO_SORTING,
};

type PriceCalendarDto = "showAllPrices" | "showSelectedDatePrices" | "hideAllPrices";
export const PriceCalendarMapping: Record<PriceCalendar, PriceCalendarDto> = {
  [PriceCalendar.SHOW_ALL_PRICES]: "showAllPrices",
  [PriceCalendar.SHOW_SELECTED_DATE_PRICES]: "showSelectedDatePrices",
  [PriceCalendar.HIDE_ALL_PRICES]: "hideAllPrices",
};
export const PriceCalendarReverseMapping: Record<PriceCalendarDto, PriceCalendar> = {
  showAllPrices: PriceCalendar.SHOW_ALL_PRICES,
  showSelectedDatePrices: PriceCalendar.SHOW_SELECTED_DATE_PRICES,
  hideAllPrices: PriceCalendar.HIDE_ALL_PRICES,
};

type ShowExtrasConfigurationDto = "expandDesktop" | "expanded" | "collapsed";
export const ShowExtrasConfigurationMapping: Record<
  ShowExtrasConfiguration,
  ShowExtrasConfigurationDto
> = {
  [ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT]: "expanded",
  [ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT_DESKTOP]: "expandDesktop",
  [ShowExtrasConfiguration.HIDE_EXTRAS_BEFORE_CHECKOUT]: "collapsed",
};
export const ShowExtrasConfigurationReverseMapping: Record<
  ShowExtrasConfigurationDto,
  ShowExtrasConfiguration
> = {
  expanded: ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT,
  expandDesktop: ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT_DESKTOP,
  collapsed: ShowExtrasConfiguration.HIDE_EXTRAS_BEFORE_CHECKOUT,
};

export interface BehaviourDto {
  roomSelectionViewType: RoomSelectionViewType;
  inventoryGroupingCriteria: InventoryGroupingCriteriaDto;
  showBookingForm: StringBoolean;
  showDesktopLogo: StringBoolean;
  showMobileLogo: StringBoolean;
  showPromos: StringBoolean;
  showCancelMsg: StringBoolean;
  showLanguageSelector: StringBoolean;
  showCurrencySelector: StringBoolean;
  showDiscountsCalculation: StringBoolean;
  showAllReservationsIds: StringBoolean;
  showFullReservationIds: StringBoolean;
  hideObligatoryExtras: StringBoolean;
  showBestPriceGuaranteed: StringBoolean;
  showMultipleAccommodations: StringBoolean;
  maxAccommodationsMultiReservation: string;
  showCookiePolicy: StringBoolean;
  showInventoryPriceDiff: StringBoolean;
  showInactiveDiscounts: StringBoolean;
  showRestrictedHighlightMessages: StringBoolean;
  waitingListEnabled: StringBoolean;
  showCheckoutButtonRoomUnits: StringBoolean;
  logolinkstohotel: StringBoolean;
  showOccupationAlternatives: OccupationAlternatives;
  splitStayConfiguration: SplitStay;
  maxHabitacionesFront: string;
  maxHabitacionesParaOcultarSoloQuedan: string;
  accommodationsOrder: AccommodationSortingCriteriaDto;
  promoCode: ShowPromoCodeCriteria;
  priceCalendar: PriceCalendarDto;
  servicesCollapsed: ShowExtrasConfigurationDto;
  pendingAmountTextConfiguration: PendingAmountTextConfiguration;
  depositRequiredTextConfiguration: DepositRequiredTextConfiguration;
  depositNotRequiredTextConfiguration: DepositNotRequiredTextConfiguration;
  taxesText: TaxesText;
  unavailableURL: string;
  witbookerPageTitle: string;
  urlwebhotel: string;
  ocultarBloqueadas: StringBoolean;
  ocultarRestringuidas: StringBoolean;
  tachaPrecios: StringBoolean;
  hasRoomCombination: StringBoolean;
  addObligatoryExtrasRateToRoomSelection: StringBoolean;
  showDecimalsInExtrasPage: StringBoolean;
  isCancellationReasonRequired: StringBoolean;
  bundlingConfiguration: StringBoolean;
  bundlingAvailability: StringBoolean;
  allowMultiplyPriceByUnits: StringBoolean;
  depositCheckoutTextConfiguration: DepositCheckoutTextConfiguration;
  extrasTextConfiguration: ExtrasTextConfiguration;
  taxesRateType: RateType;
  overrideCurrencyAccordingToLocation: StringBoolean;
}
